import React from 'react';
import {Container} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import HomeFooter from '../components/HomeFooter';
import HomeReturnLink from '../components/HomeReturnLink';
import '../styling/live-demo.css';
import '../styling/live-demo-illustration.css';

export default function LiveDemo() {
    return (
        <>
            <main className="live-demo-page">
                <section className="live-demo-section" aria-labelledby="live-demo-title">
                    <Container className="live-demo-container">
                        <div className="live-demo-home-link">
                            <HomeReturnLink />
                        </div>

                        <div className="live-demo-card">
                <div className="live-demo-construction-icon" aria-hidden="true">
                    <svg viewBox="0 0 64 64" focusable="false">
                        <path d="M12 50h40M17 45h30l-3-18H20zM22 36h20M25 45l-3 5m20-5 3 5" />
                        <path d="M22 25a10 10 0 0 1 20 0v2H22zM18 27h28M28 15v-3m8 3v-3" />
                    </svg>
                </div>
                            <p className="live-demo-eyebrow">XENKIA LIVE DEMO</p>
                            <h1 id="live-demo-title">A hands-on demo is on its way</h1>
                            <p className="live-demo-description">
                                We’re preparing a live experience where you can explore interactive 3D products and augmented reality with Xenkia.
                            </p>

                            <div className="live-demo-status" role="status">
                                <span className="live-demo-status-dot" aria-hidden="true" />
                                Under construction
                            </div>

                            <p className="live-demo-note">We’re putting the finishing touches on this page. Please check back soon.</p>
                            <Link className="live-demo-home-button" to="/">
                                Explore sample models
                                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                                    <path d="M5 12h13m-5-5 5 5-5 5" />
                                </svg>
                            </Link>
                        </div>
                    </Container>
                </section>
            </main>
            <HomeFooter />
        </>
    );
}
